module.exports = __webpack_public_path__ + "static/media/logo-fc-consultores.03c0c41e.png";